import { useEffect, useRef } from '@wordpress/element';
import ApexCharts from 'apexcharts';

import { userInformationChartData } from '../../includes/options';

export default function UserInformationChart({loadingState, response}) {

    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);

    useEffect(() => {
        if (loadingState || !chartRef.current || typeof ApexCharts === 'undefined') {
            return;
        }

        const getChartOptions = () => {
            return {
              series: response,
              colors: userInformationChartData.colors,
              chart: {
                height: 350,
                width: "100%",
                type: "donut",
              },
              stroke: {
                colors: ["transparent"],
                lineCap: "",
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontFamily: "Poppins, sans-serif",
                        offsetY: 20,
                      },
                      total: {
                        showAlways: true,
                        show: true,
                        label: "Total Wholesalers",
                        fontFamily: "Poppins, sans-serif",
                        formatter: function (w) {
                          const sum = w.globals.seriesTotals.reduce((a, b) => {
                            return a + b;
                          }, 0)
                          return sum.toLocaleString();
                        },
                      },
                      value: {
                        show: true,
                        fontFamily: "Poppins, sans-serif",
                        offsetY: -20,
                        formatter: function (value) {
                          return value.toLocaleString();
                        },
                      },
                    },
                    size: "70%",
                  },
                },
              },
              grid: {
                padding: {
                  top: -2,
                },
              },
              labels: userInformationChartData.labels,
              dataLabels: {
                enabled: false,
              },
              legend: {
                position: "bottom",
                fontFamily: "Poppins, sans-serif",
                fontSize: '14px !important'
              },
              yaxis: {
                labels: {
                  formatter: function (value) {
                    return value.toLocaleString();
                  },
                },
              },
              xaxis: {
                labels: {
                  formatter: function (value) {
                    return value.toLocaleString();
                  },
                },
                axisTicks: {
                  show: false,
                },
                axisBorder: {
                  show: false,
                },
              },
            }
          }
        
        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }

        const chart = new ApexCharts(chartRef.current, getChartOptions());
        chartInstanceRef.current = chart;
        chart.render();

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [loadingState, response]);

    return (
        <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 user-chart">
            <h3 className="component-heading">User Information</h3>
            {loadingState ? <Skeleton /> : <div ref={chartRef}></div>}
        </div>
    );
}

function Skeleton() {
  return (
    <>
    <div role="status" className="flex items-center justify-center rounded-full bg-gray-200 animate-pulse relative" style={{ height: '240px', width: '240px', margin: '0 auto', marginBottom: '30px' }}>
      <div className="absolute bg-white rounded-full" style={{ height: '168px', width: '168px' }}></div>
      <div class="h-2 bg-gray-200 rounded-full max-w-[460px] mb-2.5"></div>
      <span className="sr-only">Loading chart...</span>
    </div>
    <div role="status" className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center">
      <div className="w-full" style={{ display: 'flex', 'flexWrap': 'wrap', 'gap': '10px', margin: '0 auto', justifyContent: 'center' }}>
      <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '150px' }}></div>
      <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '150px' }}></div>
      <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '150px' }}></div>
      <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '150px' }}></div>
      </div>
      <span className="sr-only">Loading...</span>
  </div>
  </>
  );
}